import { useCookiesStore } from '../../stores/cookieStore';

class CookiesHelper {
  constructor() {
    window.addEventListener(
      'CookiebotOnConsentReady',
      () => {
        useCookiesStore.getState().updateCookieState();
      },
      false
    );
  }

  public renewSettings(): void {
    window.CookieConsent?.renew();
  }

  public getStatisticsCookiesAllowed(): boolean {
    return window.Cookiebot?.consent?.statistics ?? false;
  }

  public getMarketingCookiesAllowed(): boolean {
    return window.Cookiebot?.consent?.marketing ?? false;
  }

  public getAppInsightsSessionCookieValue(): string | null | undefined {
    return this.getCookieValueOrUndefined('ai_session');
  }

  public getAppInsightsUserCookieValue(): string | null | undefined {
    return this.getCookieValueOrUndefined('ai_user');
  }

  public getCookieUsageSelectionMade(): boolean {
    return window.Cookiebot?.consent?.marketing ?? false;
  }

  private getCookieValueOrUndefined(cookieName: string) {
    return window.CookieConsent?.getCookie(cookieName);
  }

  public setCookieValue(
    name: string,
    value: boolean | null,
    expiryInDays: number
  ) {
    let expires = '';
    if (expiryInDays) {
      const date = new Date();
      date.setTime(date.getTime() + expiryInDays * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
    // console.log(
    //   `Set cookie: ${name}=${value}, expires in ${expiryInDays} days`
    // );
  }
}

export default new CookiesHelper();
